<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import FormFields from './FormFields.svelte';
    export let fields = [];
    export let data = {};
    export let errors = {};

    export let field_class = "";

    let el;

    /*
    if (!data) {
        data = {};
        for (let field of fields) {
            data[field.name] = undefined;
        }
    }
    */

    let dispatch = createEventDispatcher()

    const handleSubmit = () => dispatch("submit", data);
    const handleDelete = () => dispatch("delete", data);

</script>

<form on:submit|preventDefault={handleSubmit} bind:this={el}>
    <FormFields {fields} bind:data {errors} {field_class} />

    {#if data.id}
        <div class="buttons is-pulled-left">
            <span class="button is-danger" on:click={handleDelete}>Delete</span>
        </div>
    {/if}
    <div class="buttons is-pulled-right">
        <button class="button is-primary">Save</button>
    </div>
</form>